var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsSerif: "http://www.serif.com/",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,0c13.8,0,25,11.2,25,25S38.8,50,25,50S0,38.8,0,25S11.2,0,25,0z M40,17.5c-0.4-1.3-1.4-2.4-2.8-2.8 C34.8,14.1,25,14.1,25,14.1s-9.8,0-12.2,0.7c-1.3,0.4-2.4,1.4-2.8,2.8C9.4,19.9,9.4,25,9.4,25s0,5.1,0.7,7.5 c0.4,1.3,1.4,2.4,2.8,2.8c2.4,0.7,12.2,0.7,12.2,0.7s9.8,0,12.2-0.7c1.3-0.4,2.4-1.4,2.8-2.8c0.7-2.4,0.7-7.5,0.7-7.5 S40.6,19.9,40,17.5z M21.9,29.7v-9.4L30,25C30,25,21.9,29.7,21.9,29.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.dd9d6758a4277b94b2277566071fbf7a.svg";
export { ForwardRef as ReactComponent };